import React, {useEffect, useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {createClient, updateClient, selectClients} from './clientsSlice';

import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';
// import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import {makeStyles, useTheme, withStyles} from '@material-ui/core/styles';

const ColorButton = withStyles((theme) => ({
  root: {
    // margin: theme.spacing(3, 0, 2),
    margin: theme.spacing(0, 0, 0),
    backgroundColor: '#D86D7E',
    color: '#FFF',
    '&:hover': {
      opacity: 0.9,
      backgroundColor: '#D86D7E',
    },
    width: '100%',
    // fontWeight: 'bold',
  },
}))(Button);

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  outer: {display: 'flex', flexFlow: 'column'},
  addIcon: {
    marginRight: 8,
    color: '#fff',
  },
  title: {
    color: '#fff',
    padding: 16,
    backgroundColor: ' #42494E',
    textAlign: 'center',
    fontSize: 24,
    fontWeight: 'bold',
  },
  textItem: {
    marginBottom: 16,
  },
}));

export default function Client(props) {
  const {edit, product} = props;
  let jwtToken = localStorage.getItem('coreToken');
  const dispatch = useDispatch();
  const [editClient, setEditClient] = useState(false);
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [mobile, setMobile] = useState('');
  const [fax, setFax] = useState('');
  const [pointRatio, setPointRatio] = useState('');
  const [website, setWebsite] = useState('');
  const [description, setDescription] = useState('');
  //street
  const [po, setPO] = useState('');
  const [streetNumber, setStreetNumber] = useState('');
  const [streetName, setStreetName] = useState('');
  const [postCode, setPostCode] = useState('');
  const [suburb, setSubarb] = useState('');

  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [country, setCountry] = useState('');

  //postal
  const [poPostal, setPOPostal] = useState('');
  const [streetNumberPostal, setStreetNumberPostal] = useState('');
  const [streetNamePostal, setStreetNamePostal] = useState('');
  const [postCodePostal, setPostCodePostal] = useState('');
  const [suburbPostal, setSubarbPostal] = useState('');

  const [cityPostal, setCityPostal] = useState('');
  const [statePostal, setStatePostal] = useState('');
  const [countryPostal, setCountryPostal] = useState('');

  const [statusIDs, setStatusIDs] = useState([]);
  const [statusList, setStatusList] = useState([
    {id: 1, value: 'active'},
    {id: 2, value: 'inactive'},
    {id: 3, value: 'deleted'},
    {id: 4, value: 'unavailable'},
  ]);
  const [localization, setLocalization] = useState([]);
  const [productStatus, setProductStatus] = useState('');
  const [addressMatch, setAddressMatch] = useState(false);
  const {editing, client, clientsAmount} = useSelector(selectClients);
  useEffect(() => {
    if (editing && client !== {}) {
      setEditClient(true);
      setName(client.name);
      setEmail(client.emailAddress);
      setPhone(client.phoneNumber);
      setMobile(client.mobileNumber);
      setDescription(client.description);
      setPointRatio(client.pointRatio);
      setWebsite(client.websiteURL);
      //street
      setPO(client.streetAddress.poBox);
      setStreetNumber(client.streetAddress.streetNumber);
      setStreetName(client.streetAddress.streetName);
      setPostCode(client.streetAddress.postCode);
      setSubarb(client.streetAddress.suburb);

      setCity(client.streetAddress.city);
      setState(client.streetAddress.state);
      setCountry(client.streetAddress.country);
      //postal
      setPOPostal(client.postalAddress.poBox);
      setStreetNumberPostal(client.postalAddress.streetNumber);
      setStreetNamePostal(client.postalAddress.streetName);
      setPostCodePostal(client.postalAddress.postCode);
      setSubarbPostal(client.postalAddress.suburb);
      setCityPostal(client.postalAddress.city);
      setStatePostal(client.postalAddress.state);
      setCountryPostal(client.postalAddress.country);

      setStatusIDs(client.statusID);
      setProductStatus(statusList[client.statusID - 1].value);
      setLocalization(client.localization ? client.localization : 1);
      setOpen(true);
    }
  }, [client]);

  const handleClickOpen = () => {
    setEditClient(false);
    setName('');
    setEmail('');
    setPhone('');
    setMobile('');
    setDescription('');
    setPointRatio('');
    setWebsite('');
    //street
    setPO('');
    setStreetNumber('');
    setStreetName('');
    setPostCode('');
    setSubarb('');

    setCity('');
    setState('');
    setCountry('');
    //postal
    setPOPostal('');
    setStreetNumberPostal('');
    setStreetNamePostal('');
    setPostCodePostal('');
    setSubarbPostal('');

    setCityPostal('');
    setStatePostal('');
    setCountryPostal('');

    setStatusIDs([]);
    setProductStatus([]);
    setLocalization([]);
    setOpen(true);
  };

  const handleClose = () => {
    setEditClient(false);
    setName('');
    setEmail('');
    setPhone('');
    setMobile('');
    setDescription('');
    setPointRatio('');
    setWebsite('');

    //street
    setPO('');
    setStreetNumber('');
    setStreetName('');
    setPostCode('');
    setSubarb('');

    setCity('');
    setState('');
    setCountry('');
    //postal
    setPOPostal('');
    setStreetNumberPostal('');
    setStreetNamePostal('');
    setPostCodePostal('');
    setSubarbPostal('');

    setCityPostal('');
    setStatePostal('');
    setCountryPostal('');

    setStatusIDs([]);
    setProductStatus([]);
    setLocalization([]);

    setOpen(false);
  };

  const handleStatusChange = (event) => {
    let selectedStatus = statusList.filter(
      (status) => status.value === event.target.value
    );
    selectedStatus[0] && setStatusIDs(selectedStatus[0].id);

    setProductStatus(event.target.value);
  };

  const handleAddressToggle = () => {
    setAddressMatch(!addressMatch);
  };

  const handleCreate = () => {
    let clientData = {
      statusID: statusIDs,
      name: name,
      description: description,
      emailAddress: email,
      phoneNumber: phone,
      mobileNumber: mobile,
      approvalProcessID: 1,
      pointRatio: pointRatio,
      websiteURL: website,
      streetAddress: {
        poBox: po,
        streetNumber: streetNumber,
        streetName: streetName,
        suburb: suburb,
        postCode: postCode,
        city: city,
        state: state,
        country: country,
      },
      postalAddress: {
        poBox: addressMatch ? po : poPostal,
        streetNumber: addressMatch ? streetNumber : streetNumberPostal,
        streetName: addressMatch ? streetName : streetNamePostal,
        suburb: addressMatch ? suburb : suburbPostal,
        postCode: addressMatch ? postCode : postCodePostal,
        city: addressMatch ? city : cityPostal,
        state: addressMatch ? state : statePostal,
        country: addressMatch ? country : countryPostal,
      },
    };

    dispatch(
      createClient({
        client: clientData,
        token: jwtToken,
        clientsAmount: clientsAmount
      })
    );
  };

  const handleUpdate = () => {
    let clientData = {
      statusID: statusIDs,
      name: name,
      description: description,
      emailAddress: email,
      phoneNumber: phone,
      mobileNumber: mobile,
      pointRatio: pointRatio,
      websiteURL: website,
      streetAddress: {
        poBox: po,
        streetNumber: streetNumber,
        streetName: streetName,
        suburb: suburb,
        postCode: postCode,
        city: city,
        state: state,
        country: country,
      },
      postalAddress: {
        poBox: addressMatch ? po : poPostal,
        streetNumber: addressMatch ? streetNumber : streetNumberPostal,
        streetName: addressMatch ? streetName : streetNamePostal,
        suburb: addressMatch ? suburb : suburbPostal,
        postCode: addressMatch ? postCode : postCodePostal,
        city: addressMatch ? city : cityPostal,
        state: addressMatch ? state : statePostal,
        country: addressMatch ? country : countryPostal,
      },
    };

    dispatch(
      updateClient({
        updatedClient: clientData,
        token: jwtToken,
        id: client.id,
        clientsAmount: clientsAmount
      })
    );
  };

  const classes = useStyles();
  const theme = useTheme();
  // const [open, setOpen] = React.useState(false);

  return (
    <div>
      <IconButton
        aria-label="add new"
        style={product ? {marginTop: 16} : {marginLeft: 0}}
      >
        <AddCircleIcon
          style={product ? {marginRight: 0} : {marginRight: 0, color: '#fff'}}
          onClick={handleClickOpen}
        />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
        fullWidth={true}
        maxWidth="lg"
        scroll="paper"
      >
        <DialogTitle
          disableTypography
          className={classes.title}
          id="form-dialog-title"
        >
          {editClient ? 'Update Client Details' : 'Add Client'}
        </DialogTitle>
        <DialogContent style={{maxHeight: '100%'}} dividers={true}>
          <DialogContentText style={{paddingTop: 8, textAlign: 'center'}}>
            {/* {editClient ? 'Update Client Details' : 'Enter Client Details'} */}
          </DialogContentText>
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <Grid container direction="column" style={{marginBottom: 8}}>
                <Grid item sm>
                  <TextField
                    defaultValue={name}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Name"
                    type="name"
                    fullWidth
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    style={{height: 104}}
                    defaultValue={description}
                    className={classes.textItem}
                    variant="outlined"
                    multiline
                    rows={3}
                    margin="dense"
                    id="description"
                    label="Description"
                    type="description"
                    fullWidth
                    onChange={(e) => setDescription(e.target.value)}
                  />
                </Grid>

                <Grid item sm>
                  <TextField
                    defaultValue={email}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="email"
                    label="Email"
                    type="email"
                    fullWidth
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={website}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="website"
                    label="Website Url"
                    type="text"
                    fullWidth
                    onChange={(e) => setWebsite(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="column">
                <Grid item sm>
                  <TextField
                    defaultValue={phone}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="phone-number"
                    label="Phone Number"
                    type="tel"
                    fullWidth
                    onChange={(e) => setPhone(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={mobile}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="mobile"
                    label="Mobile"
                    type="tel"
                    fullWidth
                    onChange={(e) => setMobile(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={pointRatio}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="pointRatio"
                    label="Point Ratio"
                    type="text"
                    fullWidth
                    onChange={(e) => setPointRatio(Number(e.target.value))}
                  />
                </Grid>
                <Grid item sm style={{paddingTop: 8}}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{
                      width: '100%',
                    }}
                  >
                    <InputLabel htmlFor="outlined-status-simple" margin="dense">
                      Client Status
                    </InputLabel>
                    <Select
                      className={classes.textItem}
                      value={productStatus}
                      onChange={(e) => handleStatusChange(e)}
                      margin="dense"
                      label="Client Status"
                      inputProps={{
                        name: 'status',
                        id: 'outlined-status-simple',
                      }}
                    >
                      <MenuItem value="active">Active</MenuItem>
                      <MenuItem value="inactive">Inactive</MenuItem>
                      <MenuItem value="unavailable">Unavailable</MenuItem>
                      <MenuItem value="deleted">Deleted</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item sm style={{paddingTop: 8}}>
                  <FormControl
                    variant="outlined"
                    className={classes.formControl}
                    style={{
                      width: '100%',
                    }}
                  >
                    <InputLabel
                      htmlFor="outlined-localization-simple"
                      margin="dense"
                    >
                      Client Country
                    </InputLabel>
                    <Select
                      value={localization}
                      onChange={(e) => setLocalization(e.target.value)}
                      margin="dense"
                      label="Client Country"
                      inputProps={{
                        name: 'localization',
                        id: 'outlined-localization-simple',
                      }}
                    >
                      <MenuItem value="1">Australia</MenuItem>
                      <MenuItem value="2">New Zealand</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Divider />
          <Typography
            variant="body1"
            style={{textAlign: 'center', padding: 8, paddingTop: 16}}
          >
            Street Address
          </Typography>
          <Grid container direction="column">
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={po}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-po"
                    label="PO Box"
                    type="text"
                    fullWidth
                    onChange={(e) => setPO(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={streetNumber}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-number-street"
                    label="Street Number"
                    type="text"
                    fullWidth
                    onChange={(e) => setStreetNumber(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={streetName}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="street-number-street"
                label="Street Name"
                type="text"
                fullWidth
                onChange={(e) => setStreetName(e.target.value)}
              />
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={suburb}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="suburb-street"
                    label="Suburb"
                    type="text"
                    fullWidth
                    onChange={(e) => setSubarb(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={postCode}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="post-code-street"
                    label="Post Code"
                    type="text"
                    fullWidth
                    onChange={(e) => setPostCode(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={city}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="city-street"
                    label="City"
                    type="text"
                    fullWidth
                    onChange={(e) => setCity(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={state}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="state-street"
                    label="State"
                    type="text"
                    fullWidth
                    onChange={(e) => setState(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={country}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="country-street"
                label="Country"
                type="text"
                fullWidth
                onChange={(e) => setCountry(e.target.value)}
              />
            </Grid>
          </Grid>
          <Divider />
          <Typography
            variant="body1"
            style={{textAlign: 'center', padding: 8, paddingTop: 16}}
          >
            Postal Address
          </Typography>
          <Grid container direction="column">
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={poPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-po"
                    label="PO Box"
                    type="text"
                    fullWidth
                    onChange={(e) => setPOPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={streetNumberPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="street-number-street"
                    label="Street Number"
                    type="text"
                    fullWidth
                    onChange={(e) => setStreetNumberPostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={streetNamePostal}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="street-number-street"
                label="Street Name"
                type="text"
                fullWidth
                onChange={(e) => setStreetNamePostal(e.target.value)}
              />
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={suburbPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="suburb-street"
                    label="Suburb"
                    type="text"
                    fullWidth
                    onChange={(e) => setSubarbPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={postCodePostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="post-code-street"
                    label="Post Code"
                    type="text"
                    fullWidth
                    onChange={(e) => setPostCodePostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <Grid container direction="row" spacing={2}>
                <Grid item sm>
                  <TextField
                    defaultValue={cityPostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="city-street"
                    label="City"
                    type="text"
                    fullWidth
                    onChange={(e) => setCityPostal(e.target.value)}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    defaultValue={statePostal}
                    className={classes.textItem}
                    variant="outlined"
                    autoFocus
                    margin="dense"
                    id="state-street"
                    label="State"
                    type="text"
                    fullWidth
                    onChange={(e) => setStatePostal(e.target.value)}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item sm>
              <TextField
                defaultValue={countryPostal}
                className={classes.textItem}
                variant="outlined"
                autoFocus
                margin="dense"
                id="country-street"
                label="Country"
                type="text"
                fullWidth
                onChange={(e) => setCountryPostal(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions
          style={{paddingLeft: 24, paddingRight: 24, paddingBottom: 16}}
        >
          <Grid container spacing={2} direction="row">
            <Grid item sm>
              <ColorButton onClick={handleClose} color="primary">
                Cancel
              </ColorButton>
            </Grid>
            <Grid item sm>
              <ColorButton
                onClick={editClient ? handleUpdate : handleCreate}
                color="secondary"
              >
                {editClient ? 'Update Client' : 'Create Client'}
              </ColorButton>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </div>
  );
}

// {
//   "statusID": 2,
//   "name": "1",
//   "description": "2",
//   "emailAddress": "3",
//   "phoneNumber": "4",
//   "streetAddress": {
//     "poBox": "6",
//     "streetNumber": "7",
//     "streetName": "8",
//     "suburb": "9",
//     "postCode": "10",
//     "city": "11",
//     "state": "12",
//     "country": "13"
//   },
//   "postalAddress": {
//     "poBox": "14",
//     "streetNumber": "15",
//     "streetName": "16",
//     "suburb": "17",
//     "postCode": "18",
//     "city": "19",
//     "state": "20",
//     "country": "21"
//   }
// }
